import { create } from 'zustand'
import { UserRequest } from '../helpers/types/userRequest'
import {
	createRegisterRequest,
	findByTelegramId,
	findPending,
	permitRegistration
} from '../api/userRequest'
// import { User } from '../helpers/types/user'

export interface UserRequestState {
	// userRequest: Record<User['telegramId'], UserRequest[]>
	createRegisterRequest: (userRequest: UserRequest) => Promise<void>
	findPending: (id: number) => Promise<UserRequest>
	permitRegistration: (
		decision: 'ALLOWED' | 'REJECTED',
		telegramId: number
	) => Promise<void>
	findByTelegramId(telegramId: number): Promise<UserRequest>
	isFetched: boolean
}

export const userRequestStore = create<UserRequestState>((set) => ({
	// userRequest: {},
	isFetched: true,
	createRegisterRequest: async (userRequest) => {
		// set(() => ({ isFetched: false }))
		// try {
		// const res =
		await createRegisterRequest(userRequest)
		// set((state) => ({
		// 	userRequest: {
		// 		...state.userRequest,
		// 		[userRequest.telegramId]: [
		// 			...state.userRequest[res.id!],
		// 			userRequest
		// 		]
		// 	}
		// }))
		// 	console.log(res)
		// } catch (e) {
		// 	console.log(e)
		// }
		// set(() => ({ isFetched: true }))
	},
	findPending: async (id) => {
		const requests = await findPending(id)
		// set((state) => ({
		// 	userRequest: {
		// 		...state.userRequest,
		// 		[id]: requests
		// 	}
		// }))
		return requests
	},
	permitRegistration: async (decision, telegramId) => {
		await permitRegistration({ decision, telegramId })
		// set((state) => ({
		// 	userRequest: {
		// 		...state.userRequest,
		// 		[telegramId]: state.userRequest[telegramId].map(
		// 			(request) =>
		// 				request.telegramId === telegramId
		// 					? { ...request, status: decision }
		// 					: request
		// 		)
		// 	}
		// }))
	},
	findByTelegramId: async (telegramId) => {
		const requests = await findByTelegramId(telegramId)
		return requests
	}
}))
